// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__10kDl","Icon":"Languages_Icon__2gOwU","LanguagesSelect":"Languages_LanguagesSelect__3g95i","minimalist":"Languages_minimalist__3PPhQ"};